export const QUIZ_QUESTIONS = [
  {
    id: 'energy',
    question: 'Care e energia ta de seară?',
    answers: [
      { text: 'Adrenalină pură', emoji: '⚡', persona: 'courageous' },
      { text: 'Conectez oamenii', emoji: '✨', persona: 'inspirational' },
      { text: 'Fiu eu însumi', emoji: '💎', persona: 'authentic' },
      { text: 'Libertate totală', emoji: '🌊', persona: 'independent' },
      { text: 'Văd dincolo', emoji: '👁', persona: 'visionary' },
    ],
  },
  {
    id: 'music',
    question: 'Muzica ta de seară?',
    answers: [
      { text: 'Hip-hop & Trap', emoji: '🎤', persona: 'courageous' },
      { text: 'Pop & Mainstream', emoji: '🌟', persona: 'inspirational' },
      { text: 'Indie & Alternative', emoji: '🎸', persona: 'authentic' },
      { text: 'Electronic & House', emoji: '🎹', persona: 'independent' },
      { text: 'Chill & Lo-fi', emoji: '🎷', persona: 'visionary' },
    ],
  },
  {
    id: 'party',
    question: 'Tu la petrecere ești...',
    answers: [
      { text: 'Primul pe ring', emoji: '💃', persona: 'courageous' },
      { text: 'Sufletul grupului', emoji: '🔥', persona: 'inspirational' },
      { text: 'Vocea autentică', emoji: '🎯', persona: 'authentic' },
      { text: 'Cel care face regulile', emoji: '👑', persona: 'independent' },
      { text: 'Observatorul vizionar', emoji: '🔮', persona: 'visionary' },
    ],
  },
]

export function calculatePersona(answers) {
  const scores = { courageous: 0, inspirational: 0, authentic: 0, independent: 0, visionary: 0 }
  answers.forEach((a) => { if (a?.persona) scores[a.persona]++ })
  return Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0]
}
